import { Check, Circle } from "lucide-react";

// Multiple-choice question list used by module quizzes and the final exam.
export const QuizQuestions = ({ questions, answers, onChange }) => (
  <div className="space-y-4" data-testid="quiz-questions">
    {questions.map((q, qi) => (
      <div key={qi} className="rounded-2xl border border-[#333] bg-[#1A1A1A] p-5" data-testid={`quiz-q-${qi}`}>
        <p className="text-[11px] font-bold tracking-[0.2em] text-[var(--accent)]">Q{qi + 1}</p>
        <p className="mb-3 mt-1 text-[15px] font-semibold">{q.question}</p>
        <div className="space-y-1">
          {q.options.map((opt, oi) => {
            const sel = answers[qi] === oi;
            return (
              <button key={oi} type="button" data-testid={`quiz-q-${qi}-opt-${oi}`}
                onClick={() => { const next = [...answers]; next[qi] = oi; onChange(next); }}
                className={`flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-left text-sm transition-colors ${sel ? "bg-[#242424] text-white" : "text-neutral-400 hover:bg-white/[0.03]"}`}>
                <span className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 ${sel ? "border-[var(--accent)]" : "border-[#444]"}`}>
                  {sel && <span className="h-2.5 w-2.5 rounded-full bg-[var(--accent)]" />}
                </span>
                {opt}
              </button>
            );
          })}
        </div>
      </div>
    ))}
  </div>
);

export const AttemptNotes = ({ r }) => (
  <div className="space-y-2 text-sm">
    {!r.passed && r.attempts_used != null && (
      <p className="text-neutral-400" data-testid="attempt-info">Attempts used: {r.attempts_used} of 3{r.attempts_remaining > 0 ? ` • ${r.attempts_remaining} remaining` : ""}</p>
    )}
    {!r.passed && r.last_attempt_warning && (
      <p className="rounded-lg border border-[#f5a623] bg-[#2a1a05] p-2 text-[#f5a623]" data-testid="last-attempt-warning">LAST ATTEMPT — failing the next attempt triggers a 24-hour cooldown.</p>
    )}
    {!r.passed && r.in_cooldown && r.cooldown_until && (
      <p className="rounded-lg border border-[#ff6b6b] bg-[#2a0a0a] p-2 text-[#ff6b6b]" data-testid="cooldown-info">You've used all 3 attempts. Try again after {new Date(r.cooldown_until).toLocaleString()}.</p>
    )}
  </div>
);

export const ModuleBadge = ({ passed, current, locked, number }) => (
  <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-[13px] font-bold ${passed || current ? "bg-[var(--accent)] text-black" : "bg-[#242424] text-white"}`}>
    {passed ? <Check size={16} strokeWidth={3} /> : locked ? <Circle size={10} className="text-neutral-500" /> : number}
  </span>
);
